import React, { useState } from "react";

import { MenuItem } from "@mui/material";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowUp } from "react-icons/md";

import { Button } from "../../Form";
import { Color } from "../../Form/Button";
import { StyledMenu } from "../AnchorMenu";
import { DefaultTooltip } from "../Tooltip";
import useStyles from "./styles";

export interface MenuActionsButtonItems {
  title: string;
  action: () => void;
  disabled?: boolean;
  tooltip?: string;
}

interface MenuActionsButtonProps {
  loading: boolean;
  menuItems: MenuActionsButtonItems[];
  viewOnly?: boolean;
}

const MenuActionsButton = ({ loading, viewOnly = false, menuItems }: MenuActionsButtonProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = !!anchorEl;
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (menuItems && !menuItems.length) return null;

  const renderMenuItems = () => {
    return menuItems.map((item, index) => (
      <div key={index}>
        <DefaultTooltip title={item.tooltip ?? ""}>
          <MenuItem
            key={index}
            className={classNames(classes.menuItem)}
            disabled={item?.disabled}
            onClick={() => {
              if (item?.action) {
                item.action();
              }
              handleClose();
            }}
          >
            <span>{item.title}</span>
          </MenuItem>
        </DefaultTooltip>
      </div>
    ));
  };

  return (
    <div>
      <Button
        customColor={Color.SECONDARY}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className={classNames(classes.button, classes.actionButton, classes.menu)}
        endIcon={<MdKeyboardArrowUp />}
        loading={loading}
        disabled={viewOnly}
      >
        {translate("actions")}
      </Button>
      <StyledMenu
        id="MenuActionButton"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            marginBottom: "7px",
          },
        }}
      >
        {renderMenuItems()}
      </StyledMenu>
    </div>
  );
};

export default MenuActionsButton;
